var _desc, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgControls(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/controls") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/controls",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.6167411,17.1613394 C21.1265056,17.6711038 21.1265056,18.5007756 20.6167411,19.0140762 L18.7640386,20.8667787 C18.2542742,21.3800793 17.4245681,21.3800793 16.9113018,20.8667787 L12.7944942,16.7500054 C11.9824005,15.9379117 11.8276996,14.7250239 12.3058441,13.747655 L8.55817614,10.0000215 L6.37499195,10.0000215 L3,5.50003219 L5.24999464,3.25003755 L9.74998391,6.6250295 L9.74998391,8.80821369 L13.4976175,12.5558816 C14.4749864,12.0742353 15.6878741,12.232438 16.4999678,13.0445317 L20.6167411,17.1613394 Z M14.6613072,11.1601749 C14.3730198,11.1601749 14.0776942,11.1953311 13.792943,11.2621416 L10.9066355,8.37579971 C10.8820193,7.05744348 11.3530914,5.73558537 12.3550421,4.73363463 C13.6558202,3.43285648 15.490979,2.98986819 17.157395,3.4012022 C17.4773024,3.48205451 17.589809,3.87934666 17.357792,4.11136362 L14.7421595,6.72699612 L15.1394173,9.1140792 L17.5265347,9.51133701 L20.1421329,6.89573885 C20.3741842,6.66368755 20.771442,6.77269227 20.8487924,7.08909776 C21.2636283,8.75547944 20.8206744,10.5906382 19.51636,11.8949525 C19.0593298,12.3519827 18.5319874,12.6894682 17.9765268,12.9320595 L17.2944834,12.2500161 C16.5913601,11.5468928 15.6562198,11.1601749 14.6613072,11.1601749 Z M11.0085678,14.0429806 C10.8363232,14.7847619 10.9171755,15.5476576 11.1843486,16.2472791 L6.83906021,20.5925675 C5.96015606,21.4714716 4.53633133,21.4714716 3.65742717,20.5925675 C2.77852302,19.7136633 2.77852302,18.2898386 3.65742717,17.4109344 L9.0152063,12.0496191 L11.0085678,14.0429806 Z M5.24999464,19.843748 C5.71756478,19.843748 6.09374262,19.4640683 6.09374262,19 C6.09374262,18.5324299 5.71756478,18.156252 5.24999464,18.156252 C4.78242449,18.156252 4.40624665,18.5324299 4.40624665,19 C4.40624665,19.4640683 4.78592638,19.843748 5.24999464,19.843748 Z",
    id: "controls",
    fill: "#40B3DB",
    fillRule: "nonzero"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgControls);
export default __webpack_public_path__ + "static/media/controls.147a3959.svg";
export { ForwardRef as ReactComponent };